import { ReactNode } from 'react';
import ScrewFixLogo from '@/assets/logos/logo.webp';
import { PHONE_DISPLAY, EMAIL, PHONE_NUMBER } from '@/constants/variables';

interface AppHeaderProps {
  leftSide?: ReactNode;
  rightSide?: ReactNode;
  onBackButtonClick?: () => void;
}

export const AppHeader = ({}: AppHeaderProps) => {
  return (
    <div className="fixed w-full h-[80px] min-h-[80px] z-2 flex flex-row items-center bg-white justify-center shadow-md">
      <div className="w-full h-[80px] min-h-[80px] z-2 flex flex-row items-center bg-white justify-between max-w-[1120px]">
        <div className="h-full flex items-center justify-start pl-10 sm:pl-20 ">
          <img
            alt="Screwfix Custom Logo"
            className="block w-auto h-auto max-h-[40%] sm:max-h-[70%] object-contain"
            src={ScrewFixLogo}
          />
        </div>

        <div className="flex flex-col items-end justify-evenly h-full pr-10 sm:pr-20 text-[clamp(17px,1.5vw,22px)]">
          <a href={`tel:${PHONE_NUMBER}`} className="mt-7 sm:mt-3">
            {PHONE_DISPLAY}
          </a>
          <a href={`mailto:${EMAIL}`} className="mb-7 sm:mb-3">
            {EMAIL}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
